import { Component, Input } from '@angular/core'

@Component({
  selector: 'minimums',
  templateUrl: './minimums.component.html',
  styleUrls: ['./minimums.component.scss'],
})
export class MinimumsComponent {
  @Input() minimum: any;
  @Input() minimums: any;
  @Input() is529: any;

  isNumber(number: any): boolean {
    return !isNaN(Number(number))
  }
}
